import React, { Component } from 'react';
import { isEmpty, validateFloat, trimFloat } from '../../Common/Common';
import Switch from '../../Part_Sample/Switch';
import Dropdown from '../../Part_Sample/Dropdown';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Select from '../../Part_Sample/Select';

import Command_Stat from '../../Commands/Interlock_Commands/Input/Command_Stat';
import Command_Error from '../../Commands/Interlock_Commands/Input/Command_Error';
import Command_Alert from '../../Commands/Interlock_Commands/Input/Command_Alert';
import Command_RT from '../../Commands/Interlock_Commands/Input/Command_RT';
import Command_Mode from '../../Commands/Interlock_Commands/Input/Command_Mode';
import Command_Value from '../../Commands/Interlock_Commands/Input/Command_Value';
import Command_RT_Offset from '../../Commands/Interlock_Commands/Input/Command_RT_Offset';
import Command_Value_Offset from '../../Commands/Interlock_Commands/Input/Command_Value_Offset';
import Command_Lock from '../../Commands/Interlock_Commands/Input/Command_Lock';
import Command_Selection from '../../Commands/Interlock_Commands/Input/Command_Selection';
import Command_Occupied from '../../Commands/Interlock_Commands/Input/Command_Occupied';

export default class Add_Edit_Condition_Detail extends Component {
	constructor(props) {
		super(props);
		this.condition_detail = {};
		this.program = JSON.parse(JSON.stringify(this.props.param.program));
		let condition_type = 'fixed';
		let selected_offset_point_id = '';
		let offset_condition = '>';
		let offset_value = '0';

		this.condition_detail = JSON.parse(JSON.stringify(this.props.param.condition_detail));
		if (isEmpty(this.props.param.condition_detail.value)) {
			// Set up default fix and ofset values
			switch (this.condition_detail.type) {
				case 'stat':
					// Selection 
					if (window.app.state.point_list[this.condition_detail.mp].type == 'Selection') {
						this.condition_detail.value = { fix: 'Pressed 1 Time' };
						this.condition_detail.condition = '=';
					}
					// Lock
					else if (window.app.state.point_list[this.condition_detail.mp].type == 'Lock') {
						this.condition_detail.value = { fix: 'close' };
						this.condition_detail.condition = '=';
					}
					else {
						this.condition_detail.value = { fix: 'off' };
						this.condition_detail.condition = '=';
					}
					break;
				case 'error':
				case 'alert':
					this.condition_detail.value = { fix: 'true' };
					this.condition_detail.condition = '=';
					break;
				case 'rt':
					this.condition_detail.value = { fix: '16', ofset: offset_value };
					this.condition_detail.condition = offset_condition;
					break;
				case 'mode':
					this.condition_detail.value = { fix: 'C' };
					this.condition_detail.condition = '=';
					break;
				case 'value':
					this.condition_detail.value = { fix: '0', ofset: offset_value };
					this.condition_detail.condition = offset_condition;
					break;
				default:

			}
		} else {
			if (this.condition_detail.value.ofset != null) {
				condition_type = 'offset';
				selected_offset_point_id = this.condition_detail.value.mp;
				offset_condition = this.condition_detail.condition;
				offset_value = this.condition_detail.value.ofset;
			}

			if(this.condition_detail.type == 'rt') {
				if(this.condition_detail.value.hasOwnProperty('fix')) {
					this.condition_detail.value.ofset = '0';
				} else {
					this.condition_detail.value.fix = '16';
				}
			}

			if(this.condition_detail.type == 'value') {
				if(this.condition_detail.value.hasOwnProperty('fix')) {
					this.condition_detail.value.ofset = '0';
				} else {
					this.condition_detail.value.fix = '0';
				}
			}
		}

		// Populate the dropdown list for offset with Management Point names
		let drop_down_list = [];
		let li = {};
		let dropdown_header = '';

		for (let point_id in window.app.state.point_list) {
			if (point_id == this.condition_detail.mp) continue;
			let point = window.app.state.point_list[point_id];

			if ( this.condition_detail.type == 'rt' || this.condition_detail.type == 'value' ) {
				if(['Ac', 'Value', 'Level', 'LevelSw'].includes(point.type)) {
					drop_down_list.push(<option value={point_id} key={point_id}>{point.name}</option>);

					// Tommy - 24/09/21 - If no selected_offset_point_id set, will set to first point in drop_down_list. (Usually only happens in creating new interlock condition)
					if ((drop_down_list.length == 1 && isEmpty(this.condition_detail.value.mp)) || point_id == selected_offset_point_id) {
						dropdown_header = point.name;
						selected_offset_point_id = point_id;
					}
				}
			}
		}

		this.state = {
			condition_type: condition_type, // condition type can be fixed or offset
			drop_down_list: drop_down_list,
			dropdown_header: dropdown_header,

			selected_offset_point_id: selected_offset_point_id,
			offset_condition: offset_condition,
			offset_value: offset_value,
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Add_Edit_Input_Condition', { condition_index: this.props.param.condition_index, condition_detail: this.props.param.condition_detail, op_type: this.props.param.op_type, program: this.props.param.program, program_id: this.props.param.program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
	}

	handleChangeStat = (operator, val) => {
		this.condition_detail.condition = operator;
		this.condition_detail.value = val;
	}

	handleChangeConditionType = (type) => {
		this.setState({ condition_type: type });
	}

	handleChangeOffsetMP = (selected_offset_point_id) => {
		let dropdown_header = '';

		if (window.app.state.point_list[selected_offset_point_id] != null) {
			let point_info = window.app.state.point_list[selected_offset_point_id];
			dropdown_header = point_info.name;
		}

		this.setState({
			dropdown_header: dropdown_header,
			selected_offset_point_id: selected_offset_point_id,
		})
	}

	handleChangeOffsetVal = (operator, val) => {
		this.condition_detail.condition = operator;
		this.condition_detail.value = val;

		this.setState({
			offset_condition: operator,
			offset_value: val.ofset,
		})
	}

	handleRegister = () => {
		if (this.state.condition_type == 'offset' && this.state.selected_offset_point_id == '') {
			window.app.showToast(this.props.receiver.getString('no_target'), 3000);
			return;
		}

		let temp_value = {};

		if (this.state.condition_type == 'fixed') {
			// type: "stat"/"error"/"alert"/"rt"/"mode"/"value"
			// Check if condition detail type is supposed to have a number input
			if (this.condition_detail.type == 'value' || this.condition_detail.type == 'rt') {
				if (!validateFloat(this.condition_detail.value.fix)) {
					window.app.showToast(this.props.receiver.getString('invalid_input'), 3000);
					return;
				} else {
					this.condition_detail.value.fix = trimFloat(this.condition_detail.value.fix);
				}
			} else if (this.condition_detail.type == 'error' || this.condition_detail.type == 'alert') {
				if (typeof this.condition_detail.value.fix == 'string') {
					if (this.condition_detail.value.fix == 'true') this.condition_detail.value.fix = true;
					else if (this.condition_detail.value.fix == 'false') this.condition_detail.value.fix = false;
				}
			}

			temp_value.fix = this.condition_detail.value.fix;
			this.condition_detail.value = temp_value;
		} else if (this.state.condition_type == 'offset') {
			if (!validateFloat(this.condition_detail.value.ofset)) {
				window.app.showToast(this.props.receiver.getString('invalid_input'), 3000);
				return;
			} else {
				this.condition_detail.value.ofset = trimFloat(this.condition_detail.value.ofset);
			}
			temp_value.mp = this.state.selected_offset_point_id;
			temp_value.type = this.condition_detail.type;
			temp_value.ofset = this.condition_detail.value.ofset;
			this.condition_detail.value = temp_value;
		}

		let param = this.props.param;
		// Check for exiting condition
		for (let index in param.program.condition) {
			let existing_condition = param.program.condition[index];
			if (existing_condition.mp == this.condition_detail.mp
				&& existing_condition.type == this.condition_detail.type
				&& existing_condition.condition == this.condition_detail.condition
				&& index != this.props.param.condition_index) {

				if (existing_condition.value.fix != null) {
					if (existing_condition.value.fix == this.condition_detail.value.fix) {
						window.app.showToast(this.props.receiver.getString('action_exists'), 3000);
						return;
					}
				} else if (existing_condition.value.ofset != null) {
					if (existing_condition.value.ofset == this.condition_detail.value.ofset) {
						window.app.showToast(this.props.receiver.getString('action_exists'), 3000)
						return;
					}
				}
			}
		}

		this.program.condition[param.condition_index] = this.condition_detail;
		param.program = this.program;
		delete param.condition_detail;
		delete param.condition_index;

		this.props.content_handler('Edit_Interlock_Input', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			background: 'white',
			width: this.props.width,
			textAlign: 'left',
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 15,
			cursor: 'pointer',
		}

		let dropdown_right_margin = (this.props.width - 200) / 2;
		let Dynamic_Content_Fixed = null;

		switch (this.condition_detail.type) {
			case 'stat':
				if (window.app.state.point_list[this.condition_detail.mp].type == 'Selection') {
					Dynamic_Content_Fixed =
						<Command_Selection receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				} else if (window.app.state.point_list[this.condition_detail.mp].type == 'Lock') {
					Dynamic_Content_Fixed =
						<Command_Lock receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				} else if (window.app.state.point_list[this.condition_detail.mp].type == 'Occupied') {
					Dynamic_Content_Fixed =
						<Command_Occupied point_info={window.app.state.point_list[this.condition_detail.mp]} receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				} else {
					Dynamic_Content_Fixed =
						<Command_Stat receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				}
				break;
			case 'error':
				Dynamic_Content_Fixed =
					<Command_Error receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				break;
			case 'alert':
				Dynamic_Content_Fixed =
					<Command_Alert receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				break;
			case 'rt':
				Dynamic_Content_Fixed =
					<Command_RT receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				break;
			case 'mode':
				Dynamic_Content_Fixed =
					<Command_Mode receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				break;
			case 'value':
				Dynamic_Content_Fixed =
					<Command_Value receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeStat} />
				break;
			default:
				Dynamic_Content_Fixed = null;
		}

		let selected_device_name = '';
		let point_info = window.app.state.point_list[this.condition_detail.mp];
		if (!isEmpty(point_info)) selected_device_name = point_info.name;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('condition')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div id="scrollable_content" style={{ height: this.props.height - 140, overflow: 'auto', paddingBottom: 60 }}>

						<div style={{ ...button_style, opacity: this.state.condition_type == 'fixed' ? 1 : 0.2 }} onClick={() => this.handleChangeConditionType('fixed')}>
							<div style={{ marginLeft: 20 }}>
								<span className='title'>{this.props.receiver.getString('fixed_val_instr')}</span>
							</div>
							{Dynamic_Content_Fixed}
						</div>

						<div style={{ ...button_style, opacity: this.state.condition_type == 'offset' ? 1 : 0.2, marginTop: 20, display: this.condition_detail.type == 'value' || this.condition_detail.type == 'rt' ? 'block' : 'none' }} onClick={() => this.handleChangeConditionType('offset')}>
							<div style={{ marginLeft: 20 }}>
								<span className='title'>{this.props.receiver.getString('offset_instr')}</span>
							</div>

							<Select
								style={{ textAlign: 'center', marginTop: 20 }}
								select_style={{ width: '80%' }}
								options={this.state.drop_down_list}
								value={this.state.selected_offset_point_id}
								onSelect={this.handleChangeOffsetMP}
							/>

							<div style={{ marginTop: 20, }}>
								<div style={{ marginLeft: 20 }}>
									<span>{this.props.receiver.getString('offset_label')}</span>
								</div>
								<div style={{ display: this.condition_detail.type == 'rt' ? 'block' : 'none' }}>
									<Command_RT_Offset receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeOffsetVal} offset_point_id={this.state.selected_offset_point_id} />
								</div>
								<div style={{ display: this.condition_detail.type == 'value' ? 'block' : 'none' }}>
									<Command_Value_Offset receiver={this.props.receiver} width={this.props.width} condition_detail={this.condition_detail} handleChangeStat={this.handleChangeOffsetVal} offset_point_id={this.state.selected_offset_point_id} />
								</div>
							</div>
							<div style={{ marginTop: 20, }}>
								<div style={{ marginLeft: 10 }}>
									<span className='footnote'>{this.props.receiver.getString('offset_eg_label') + ': '}</span>
								</div>
								<div style={{ marginLeft: 20 }}>
									<div style={{ display: 'inline-block' }}>
										<span className='footnote'>{selected_device_name}</span>
									</div>
									<div style={{ display: 'inline-block' }}>
										<span className='footnote' style={{ fontWeight: 'bold' }}>{this.state.offset_condition}</span>
									</div>
									<div style={{ display: 'inline-block' }}>
										<span className='footnote' style={{ fontWeight: 'bold' }}>{this.state.dropdown_header}</span>
									</div>
									<div style={{ display: 'inline-block' }}>
										<span className='footnote' style={{ fontWeight: 'bold' }}>{this.state.offset_value >= 0 ? '+' : ''} {this.state.offset_value}</span>
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>
		)
	}
}